import { render, staticRenderFns } from "./write.vue?vue&type=template&id=122f22e9&scoped=true&"
import script from "./write.vue?vue&type=script&lang=js&"
export * from "./write.vue?vue&type=script&lang=js&"
import style0 from "./write.vue?vue&type=style&index=0&id=122f22e9&prod&scoped=true&lang=css&"
import style1 from "./write.vue?vue&type=style&index=1&id=122f22e9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122f22e9",
  null
  
)

export default component.exports